<template>
    <div class="side-box">
        <v-layout justify-space-between align-center class="side-box-header">
            <div class="side-box-title">{{$t('assignTo')}}</div>
            <v-icon @click="toggleAssignSupporter">mdi-close</v-icon>
        </v-layout>
        <div class="side-box-content">
            <div class="search-view">
                <div class="search-staff">
                    <input v-model="searchStaffKey" type="text" :placeholder="$t('enterNameOrEmail')">
                </div>
                <div v-if="staffList.length < 2" class="pa-3" style="text-align: center;color: #B5B5B5;">
                    {{ $t("emptySupporterAssign") }}
                </div>
                <div v-else style="overflow: auto">
                    <v-card width="100%" v-if="skillList && skillList.length > 0">
                        <v-list subheader>
                            <v-list-group value="true">
                                <template v-slot:activator>
                                    <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ $t("assignBySkill") }}</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                                <v-list-tile v-for="skill in skillList" :key="skill.id" @click="selectedSkill = skill">
                                    <v-list-tile-content style="padding-left: 30px;">
                                        <v-list-tile-title>{{ skill.name }}</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                        <v-btn color="#4977EE" dark @click="assignBySkill" class="mr-0" v-if="selectedSkill && selectedSkill.id === skill.id">Assign</v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list-group>
                        </v-list>
                    </v-card>
                    <div
                        v-for="(staff,i) in staffListFilter"
                        :key="i"
                        class="staff-item"
                        :class="{active: staff.id === activeStaff.id}"
                        @click="selectStaff(staff)"
                    >
                        <v-layout align-center>
                            <div class="staff-icon" :class="(supporters_config_map && supporters_config_map[staff.id] && supporters_config_map[staff.id].active) ? 'online' : 'offline'">
                                {{$AppService.createTextImage(staff.name ? staff.name : staff.email.split('@')[0])}}
                            </div>
                            <div class="staff-name-wrapper ml-3">
                                <span class="staff-name">{{staff.name ? staff.name : staff.email.split('@')[0]}}</span><br>
                                <span class="staff-email">{{staff.email}}</span><br>
                                <span class="staff-email">taking care of {{countSupport(staff)}} persons</span>
                            </div>
                            <v-spacer></v-spacer>
                            <div v-if="staff.id === activeStaff.id">
                                <v-btn color="#4977EE" outline small dark @click="assignTo" class="mr-0">{{ $t("assign") }}</v-btn>
                            </div>
                        </v-layout>
                    </div>
                </div>
            </div>
        </div>
        <div class="chat_view_loading" v-if="loadingDialog">
            <div class="loading_overlay"></div>
            <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
        </div>
    </div>
</template>

<script>
import StaffService from "@/services/staff.service";
import BotService from "@/services/bot.service";
import utils from "@/services/utils"
import {mapMutations, mapState} from "vuex";

export default {
    name: "AssignView",
    data () {
        return {
            loadingDialog: false,
            me: StaffService.getMe() ? StaffService.getMe() : null,
            searchStaffKey: '',
            activeStaff: {},
            supportStatus: [],
            skillList: [],
            selectedSkill: null,
            supporters_config_map: {},
        }
    },
    computed: {
        ...mapState({
            staffList: state => {
                let bot = _.find(state.botStaffList, bot => bot.bot_code === state.chatView.botCode);
                return bot.staffs
            },
            supporter: state => state.supporter,
            updateAutoAssignConfig: state => state.updateAutoAssignConfig,
            chatView: state => state.chatView,
        }),
        staffListFilter () {
            let list = this.staffList;
            let key = this.removeVietnameseTones(this.searchStaffKey.trim().toLowerCase());
            if (key) {
                list = _.filter(this.staffList, item =>
                    this.removeVietnameseTones(item.name.toLowerCase()).includes(key) ||
                    this.removeVietnameseTones(item.email.toLowerCase()).includes(key))
            }
            list = _.filter(list, item => {
                if (item.id === this.me.id) {
                    return false
                } else if (this.supporter) {
                    return item.id !== this.supporter.id
                }
                return true
            });
            return list
        },
    },
    watch: {
        updateAutoAssignConfig: {
            handler (newValue) {
                if (newValue && this.supporters_config_map && this.supporters_config_map[newValue.user_id]) {
                    this.supporters_config_map[newValue.user_id] = {
                        active: newValue.active,
                        request_support_categories: newValue.request_support_categories,
                    }
                }
            }
        },
    },
    mounted () {
        this.getSkillList();

        this.loadingDialog = true;
        StaffService.getSupportingStatus().then(
            result => {
                this.supportStatus = result.data;
            },
            this.$AppService.handleRequestError('Can not load supporting status')
        ).finally(() => {
            this.loadingDialog = false;
        })
    },
    methods: {
        ...mapMutations('sideBox', ['toggleAssignSupporter', 'hideAllSideBox']),
        selectStaff (staff) {
            this.activeStaff = staff
        },
        removeVietnameseTones: utils.removeVietnameseTones,
        assignTo (ignore_max_supporting = false) {
            StaffService.assignTo(this.activeStaff.id, this.chatView.livesupport_log, ignore_max_supporting).then(
                (response) => {
                    this.$AppService.toastSuccess('Assigned to ' + this.activeStaff.name);
                    if (response.data && response.data.livesupport_log) {
                        this.chatView.livesupport_log = response.data.livesupport_log;
                    }
                    this.hideAllSideBox();
                },
                (e) => {
                    if (e.response && e.response.status === 423) {
                        this.$AppService.toastError(this.$t('assignLocked'));
                        BotService.getBotStatus(this.chatView.senderId, this.chatView.botCode).then(
                            result => {
                                this.$store.commit(this.$ActionTypes.BOT_STATUS, result.data.status);
                                // this.$store.commit(
                                //     this.$ActionTypes.SUPPORTER,
                                //     result.data.status ? this.$const.BOT_SUPPORTER : result.data.supporter
                                // );
                                this.chatView.livesupport_log = result.data.livesupport_log;
                            },
                            this.$AppService.handleRequestError()
                        );
                    } else if (e.response && e.response.status === 400 && e.response.data && e.response.data.message === "over supporting limit") {
                        let supporting_count = e.response.data.supporting_count
                        this.$appService.confirm(this.$t('tooManySupportingAssignToOther', [supporting_count])).then(confirm => {
                            if (confirm === true) {
                                this.assignTo(true);
                            }
                        })
                    } else {
                        this.$AppService.handleRequestError('Can not assign to ' + this.activeStaff.name)
                    }
                }
            )
        },
        countSupport (staff) {
            let found = _.find(this.supportStatus, item => item.id === staff.id);
            return found ? found.number_in_support : 0
        },
        getSkillList() {
            this.loadingDialog = true;
            BotService.getAutoAssignStatus_manage(this.$store.state.bot.code).then(response => {
                this.skillList = response.data.rs_categories || [];
                let supporters = response.data.supporters || [];
                let supporters_config_map = {}
                for (let staff of supporters) {
                    supporters_config_map[staff.id] = {
                        active: staff.auto_assign_config.active,
                        request_support_categories: staff.auto_assign_config.request_support_categories,
                    }
                }
                this.supporters_config_map = supporters_config_map;
            }).catch(() => {
                this.$AppService.toastError("get auto assign config failed.");
                this.rsCategories = [];
            }).finally(() => {
                this.loadingDialog = false;
            })
        },
        assignBySkill() {
            if (!this.selectedSkill) {
                this.$AppService.toastError("skill not selected.");
                return;
            }
            this.loadingDialog = true;
            StaffService.assignBySkill(this.selectedSkill.id, this.chatView.livesupport_log).then(
                (response) => {
                    let staff = response.data ? response.data.staff : null;
                    if (staff) {
                        let message = 'Assigned to ' + (staff.name ? staff.name : staff.email);
                        this.$AppService.toastSuccess(message);
                    } else {
                        this.$AppService.toastSuccess('Assign success');
                    }
                    if (response.data && response.data.livesupport_log) {
                        this.chatView.livesupport_log = response.data.livesupport_log;
                    }
                    this.hideAllSideBox();
                },
            ).catch((e) => {
                if (e.response && e.response.status === 423) {
                    this.$AppService.toastError(this.$t('assignLocked'));
                    BotService.getBotStatus(this.chatView.senderId, this.chatView.botCode).then(
                        result => {
                            this.$store.commit(this.$ActionTypes.BOT_STATUS, result.data.status);
                            // this.$store.commit(
                            //     this.$ActionTypes.SUPPORTER,
                            //     result.data.status ? this.$const.BOT_SUPPORTER : result.data.supporter
                            // );
                            this.chatView.livesupport_log = result.data.livesupport_log;
                        },
                        this.$AppService.handleRequestError()
                    );
                } else if (e.response && e.response.data) {
                    let errorMessage = 'Assign failed: ' + e.response.data;
                    this.$AppService.toastError(errorMessage)
                } else {
                    this.$AppService.toastError('Assign failed.')
                }
            }).finally(() => {
                this.loadingDialog = false;
            })
        }
    }
}
</script>
<style scoped lang="scss" src="../style/side-box.scss"></style>
<style scoped lang="scss" src="../style/staff.scss"></style>
<style scoped lang="scss" src="../style/assign-view.scss"></style>
